<template>
  <div
    class="
      tw-gap-4 tw-grid tw-grid-cols-1 tw-w-full
      lg:tw-max-w-[256px] lg:tw-m-auto
    "
  >
    <TextField
      id="firstName"
      v-model="firstName"
      data-testid="firstName"
      name="firstName"
      rules="required|min:1|max:23"
      :placeholder="$t('forms.personal_details.first_name_placeholder')"
      :label="$t('forms.personal_details.first_name')"
    />

    <TextField
      id="lastName"
      v-model="lastName"
      data-testid="lastName"
      name="lastName"
      rules="required|min:1|max:23"
      :placeholder="$t('forms.personal_details.last_name_placeholder')"
      :label="$t('forms.personal_details.last_name')"
    />

    <DateField
      id="dob"
      v-model="dob"
      data-testid="dob"
      :max-date="today"
      name="dob"
      rules="required|minimum_age|maximum_age"
      :placeholder="$t('forms.personal_details.date_of_birth_placeholder')"
      :label="$t('forms.personal_details.date_of_birth')"
    />
  </div>
</template>

<script>
import TextField from '~/components/form-fields/TextField'
import DateField from '~/components/form-fields/DateField'

export default {
  components: {
    TextField,
    DateField,
  },
  props: {
    values: {
      type: null,
      required: true,
    },
  },
  computed: {
    today: {
      get() {
        return new Date()
      },
    },
    firstName: {
      get() {
        return this.values.firstName
      },
      set(value) {
        this.handleChange('firstName', value)
      },
    },
    lastName: {
      get() {
        return this.values.lastName
      },
      set(value) {
        this.handleChange('lastName', value)
      },
    },
    dob: {
      get() {
        return this.values.dob
      },
      set(value) {
        this.handleChange('dob', value)
      },
    },
  },
  methods: {
    handleChange(key, value) {
      const payload = this.values || {}
      this.$emit('on-change', { ...payload, [key]: value })
    },
  },
}
</script>
